module.exports = __webpack_public_path__ + "img/violet_139.73df2a17.png";